import { render, staticRenderFns } from "./TherapySelectQuestion.vue?vue&type=template&id=e95f0e2c"
import script from "./TherapySelectQuestion.vue?vue&type=script&lang=js"
export * from "./TherapySelectQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports